module.exports = __webpack_public_path__ + "static/img/yqx.1e4d613.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yqx.svg
// module id = E6M5
// module chunks = 1 2